module.exports = __webpack_public_path__ + "static/img/conveyor-pole_256.e888cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-pole_256.png
// module id = //a8
// module chunks = 0